/**
 * WARNING: The order of each item in the lists may be used in conditional statements. Add new items at the end of the
 * array in order to not introduce unwanted behavior throughout the application.
 */

/**
 * List of possible types of recall and record study.
 */
const studyTypeList = [
	{
		type: 'Unknown',
		icon: 'warning'
	},
	{
		type: 'Recall',
		icon: 'update'
	},
	{
		type: 'Record',
		icon: 'receipt_long'
	},
	{
		type: 'Consecutive Days',
		icon: 'date_range'
	},
	{
		type: 'Single Day',
		icon: 'event'
	},
	{
		type: 'Unscheduled',
		icon: 'calendar_today'
	},
	{
		type: 'Scheduled',
		icon: 'today'
	}
]

export default studyTypeList;
